export function Brand() {
  return (
    <img
      className="logo"
      src="/static/images/ccia-white-logo-transparent.png"
      alt="app-logo"
    />
  );
}
